import isString from 'lodash/isString'
import { MutableRefObject } from 'react'

export const buildAdyenComponent = (
  adyenInstance,
  type: string,
  ref: (string | MutableRefObject<HTMLElement | null> | undefined),
  adyenConfig,
  config,
) => {
  if (!!adyenInstance && adyenConfig) {
    const component = adyenInstance.create(type, {
      paymentMethods: adyenConfig?.paymentMethodsResponse?.paymentMethods,
      ...(adyenConfig.paymentMethodsResponse.paymentMethods?.find(pm => pm.type === type)?.configuration || {}),
      ...config,
    })
    if (ref) {
      const mountTo = isString(ref) ? ref : ref?.current
      component.mount(mountTo)
    }
    return component
  }
  return null
}

